import { gsap, ScrollTrigger } from "./globals.js";
import { isLargeNonTouchDevice } from './globals.js';

document.addEventListener("DOMContentLoaded", () => {
	const aboutSection = document.querySelector(".hp-about");
	if (aboutSection) {
	  const h2Elements = document.querySelectorAll(".hp-about__text-wrap h2");
	  const stats = document.querySelectorAll(".hp-about__text-wrap__stats .stat");
	  const gradient = document.querySelector(".hp-about__gradient");
	  const pagination = document.querySelectorAll(".hp-about__pagination");
	  const lineSpans = document.querySelectorAll(".hp-about__pagination .line span");
	  const aboutImgs = document.querySelectorAll(".hp-about__img");
	  const headerLogo = document.querySelectorAll(".header__scroll .header__logo");

	  const imageAnimations = [
	    { x: -100, y: -100 }, // top-left
	    { x: 100, y: -100 },  // top-right
	    { x: -100, y: 100 },  // bottom-left
	    { x: 100, y: 100 }    // bottom-right
	  ];

	  const masterTl = gsap.timeline({
	    scrollTrigger: {
	      trigger: ".hp-about",
	      start: "top top",
	      end: "+=3000",
	      scrub: 3,
	      pin: true,
	    }
	  });

	  const h2SectionDuration = h2Elements.length * 8;
	  masterTl.addLabel("h2Start");

	  // Animate H2s and line spans 1–3
	  h2Elements.forEach((h2, index) => {
		  const chars = h2.querySelectorAll(".char");
		  const label = `h2Step${index + 1}`;
		  masterTl.addLabel(label);

		  // Add character animation first — this becomes the sync anchor
		  masterTl.fromTo(chars, {
		    opacity: 0,
		     y: '5%',
		    willChange: "opacity"
		  }, {
		    opacity: 1,
		    y: 0,
		    stagger: 0.05,
		    duration: 2
		  }, label); // <- characters start at this label

		  // Animate span fill after char animation starts (same label)
		  if (lineSpans[index]) {
		    masterTl.to(lineSpans[index], {
		      scaleX: 1,
		      transformOrigin: "left",
		      duration: 3,
		      ease: "linear"
		    }, label); // syncs *with* character animation
		  }

		  // Fade out h2 after it finishes animating in
		  masterTl.to(h2, {
		    opacity: 0,
		    scale: 1.1,
		    duration: 3,
		    ease: "power1.out"
		  });

		  if (index === 2) {
			  masterTl.addLabel("imagesFadeOut", label + ">-=4");

			  aboutImgs.forEach((img, i) => {
			    masterTl.to(img, {
			      opacity: 0,
			      duration: 5,
			      ease: "linear"
			    }, "imagesFadeOut"); // ← All synced to same label
			  });
			}

		  // Add class to .pinned-slider after images fade out
		  masterTl.call(() => {
		    document.querySelector('.pinned-slider')?.classList.add('light');
		  });
	  });

	    masterTl.to(headerLogo, {
		    opacity: 0,
		    duration: .3,
		    ease: "power1.out"
		  }, "h2Step1");

	  // Animate about images once; duplicate tween creation here adds unnecessary timeline work.
	  aboutImgs.forEach((img, i) => {
	    masterTl.fromTo(img, {
	      opacity: 0,
	      x: imageAnimations[i].x,
	      y: imageAnimations[i].y,
	      willChange: "transform"
	    }, {
	      opacity: 1,
	      x: 0,
	      y: 0,
	      duration: 10,
	      ease: "power2.out"
	    }, "h2Step1"); // Now this label is already defined
	  });

	  // Animate gradient during h2s
	  if (gradient) {
	    masterTl.fromTo(gradient, {
	      scale: 0.55,
	      transformOrigin: "center center",
	      opacity: 1
	    }, {
	      scale: 1,
	      duration: h2SectionDuration,
	      ease: "none"
	    }, "h2Start");
	  }

	  masterTl.addLabel("statsStart");

	  // Animate line 4 span when stats start
	  if (lineSpans[3]) {
	    masterTl.to(lineSpans[3], {
	      scaleX: 1,
	      transformOrigin: "left",
	      duration: 3,
	      ease: "linear"
	    }, "statsStart");
	  }

	  // Animate gradient during stats
	    masterTl.to(gradient, {
	      scale: 4,
	      opacity: .2,
	      duration: 3 * stats.length,
	      ease: "power1.inOut"
	    }, "statsStart");

	    if (gradient && isLargeNonTouchDevice()) {
		  masterTl.to(pagination, {
		      opacity: 0,
		      duration: 3 * stats.length,
		      ease: "power1.inOut"
		    }, "statsStart");
		}

	  // Animate stats
	  stats.forEach((stat, i) => {
	    masterTl.fromTo(stat, {
	      opacity: 0,
	      scale: 0.8
	    }, {
	      opacity: 1,
	      duration: 5,
	      scale: 1,
	      ease: "power2.out"
	    }, `statsStart+=${i * 2}`);
	  });

		const aboutSection = document.querySelector(".hp-about");

		if (aboutImgs.length && isLargeNonTouchDevice()) {
		  let bounds = aboutSection.getBoundingClientRect();

		  // Grab all .img-inner elements
		  const imgInners = document.querySelectorAll(".hp-about__img-wrap");

		  // Store quick setters on inners, not outer image wrappers
		  const imgTransforms = Array.from(imgInners).map(inner => ({
		    x: gsap.quickTo(inner, "x", { duration: 3, ease: "power3.out" }),
		    y: gsap.quickTo(inner, "y", { duration: 3, ease: "power3.out" })
		  }));

		  aboutSection.addEventListener("mousemove", (e) => {
		    const centerX = bounds.left + bounds.width / 2;
		    const centerY = bounds.top + bounds.height / 2;
		    const offsetX = (e.clientX - centerX) / bounds.width;
		    const offsetY = (e.clientY - centerY) / bounds.height;

		    imgTransforms.forEach(({ x, y }) => {
		      const strength = 75; // Movement strength

		      // Apply movement to the x and y positions
		      x(offsetX * strength * -1);
		      y(offsetY * strength * -1);
		    });
		  });

		  window.addEventListener("resize", () => {
		    bounds = aboutSection.getBoundingClientRect();
		  }, { passive: true });
		}
	}
});
